/**
 * Cancel Page Component
 */

import React from 'react';
import { Link } from 'react-router-dom';

const Cancel: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-lg mx-auto bg-white rounded-lg shadow-xl p-8">
          {/* Cancel Icon */}
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-red-100 rounded-full mb-4">
              <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Payment Canceled
            </h1>
            <p className="text-gray-600">
              Your payment has been canceled
            </p>
          </div>

          {/* Information */}
          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <p className="text-gray-700 text-sm">
              No worries! Your information is safe and has been deleted from our temporary storage.
              You can return to the calculator anytime to complete your purchase.
            </p>
          </div>

          {/* Privacy Note */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
            <h3 className="font-semibold text-yellow-800 mb-2">🔒 Your Privacy</h3>
            <p className="text-yellow-700 text-sm">
              We do not store any personal information. Your data was only held temporarily
              and has been completely deleted.
            </p>
          </div>

          {/* Buttons */}
          <div className="space-y-3">
            <Link
              to="/calculator"
              className="block w-full text-center bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-blue-700 transition duration-300"
            >
              Return to Calculator
            </Link>

            <Link
              to="/"
              className="block w-full text-center bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg hover:bg-gray-300 transition duration-300"
            >
              Go to Home
            </Link>
          </div>

          {/* Support */}
          <div className="mt-6 text-center text-sm text-gray-600">
            <p>
              Questions?{' '}
              <a href="mailto:support@divorcecalculator.com" className="text-blue-600 hover:underline">
                Contact us
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cancel;